export default __webpack_public_path__ + "static/3-536879305e895791091153bd03913900.jpg";